import { render, staticRenderFns } from "./radioButtonUi.vue?vue&type=template&id=32fdfd4c&scoped=true"
import script from "./radioButtonUi.vue?vue&type=script&lang=js"
export * from "./radioButtonUi.vue?vue&type=script&lang=js"
import style0 from "./radioButtonUi.vue?vue&type=style&index=0&id=32fdfd4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32fdfd4c",
  null
  
)

export default component.exports